export enum EFSCompanyDirectionId {
  MaintainDirection = 60723,
  ChangeDirection = 60724
}
